<template>
    <rkm-area
        type="fieldset"
        title="Público alvo"
        v-if="showPublico"
    >

        <rkm-row>
            <rkm-col>
                <rkm-form-group>
                    <rkm-form-checkbox-group
                        v-model="data.model.publicoAlvo"
                        name="Público alvo"
                        :validations="validations.publico"
                    >
                        <rkm-row>
                            <rkm-col
                                v-for="item in data.form.publicoAlvo"
                                v-bind:key="item.id"
                                cols="6"
                            >
                                <rkm-form-checkbox
                                    :value="item.id"
                                    class="text-nowrap"
                                    inline
                                >
                                    {{ item.descricao }}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-checkbox-group>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

    </rkm-area>
</template>

<script>

//Enums
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'

export default {
    data: () => ({
        enums: {
            atividadeTipo
        },
    }),
    computed: {
        showPublico() {
            const atividadeTipoId = this.data.model.atividade.atividadeTipoId

            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO,
                this.enums.atividadeTipo.MOBILIZACAO_SOCIAL
            ]
            
            return this.data.model.publicoAlvo && tiposAtividade.includes(atividadeTipoId)
        },
        validations() {
            return {
                publico: {
                    required: this.isRequiredPublico
                }
            }
        },
        isRequiredPublico() {
            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO,
                this.enums.atividadeTipo.MOBILIZACAO_SOCIAL
            ]

            return tiposAtividade.includes(this.data.model.atividade.atividadeTipoId)
        }
    },
    watch: {
        'data.model.atividade.atividadeTipoId': function (atividade) {

            const atividadeTipoId = atividade

            const tiposAtividade = [
                this.enums.atividadeTipo.EDUCACAO_EM_SAUDE,
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO,
                this.enums.atividadeTipo.MOBILIZACAO_SOCIAL
            ]

            if (!tiposAtividade.includes(atividadeTipoId)) {
                this.data.model.publicoAlvo = []
            }

        },
    },
    props: {
        data: { type: Object, required: false, },
    }
}
</script>